import React from 'react';
import { Formik, Form } from 'formik';
import { useNavigate } from 'react-router';
import { NavLink, useParams } from 'react-router-dom';
import useEditAccount from './hooks/useEditAccount';
import { Button } from '@/src/shadComponents/ui/button';
import { Input } from '@/src/shadComponents/ui/input';
import { Label } from '@/src/shadComponents/ui/label';
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from '@/src/shadComponents/ui/card';
import PageShell from '@/src/Common/components/PageShell';

interface PasswordObject {
    password: string;
    confirmPassword: string;
}

export default function SetPassword() {
    const navigate = useNavigate();
    const { setPassword } = useEditAccount();
    const { id } = useParams();

    const passwordObject: PasswordObject = {
        password: '',
        confirmPassword: '',
    };

    const validate = (values: PasswordObject) => {
        const errors: any = {};
        const { password, confirmPassword } = values;
        if (!password) {
            errors.password = 'required';
        } else if (!confirmPassword) {
            errors.confirmPassword = 'required';
        } else if (password !== confirmPassword) {
            errors.password = 'passwords must match';
            errors.confirmPassword = 'passwords must match';
        }
        return errors;
    };

    return (
        <PageShell
            title="Set Password"
            breadcrumbs={[
                { label: 'Accounts', href: '/accounts' },
                { label: 'Set Password' },
            ]}
        >
            <Formik
                validate={validate}
                initialValues={passwordObject}
                onSubmit={async (values, actions) => {
                    const { password } = values;

                    const wasSuccessful = await setPassword(
                        parseInt(`${id}`, 10),
                        password,
                    );

                    actions.setSubmitting(false);

                    if (wasSuccessful) {
                        navigate('/accounts');
                    }
                }}
            >
                {({ errors, touched, values, handleChange, handleBlur }) => (
                    <Form
                        className="space-y-6"
                        placeholder={undefined}
                        onPointerEnterCapture={undefined}
                        onPointerLeaveCapture={undefined}
                    >
                        <Card>
                            <CardHeader>
                                <CardTitle>Set New Password</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                                    <div className="space-y-2">
                                        <Label htmlFor="password">Password</Label>
                                        <Input
                                            id="password"
                                            name="password"
                                            type="password"
                                            value={values.password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.password && touched.password && (
                                            <p className="text-sm text-destructive">{errors.password}</p>
                                        )}
                                    </div>
                                    <div className="space-y-2">
                                        <Label htmlFor="confirmPassword">Confirm Password</Label>
                                        <Input
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            type="password"
                                            value={values.confirmPassword}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.confirmPassword && touched.confirmPassword && (
                                            <p className="text-sm text-destructive">{errors.confirmPassword}</p>
                                        )}
                                    </div>
                                </div>
                            </CardContent>
                        </Card>

                        <div className="flex items-center justify-end gap-4">
                            <NavLink to="/accounts">
                                <Button type="button" variant="outline">
                                    cancel
                                </Button>
                            </NavLink>
                            <Button type="submit">
                                save
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </PageShell>
    );
}
